class ShippingEstimate extends HTMLElement {
    constructor() {
        super();
        this.dateElement = this.querySelector('[data-shipping-date]');
        this.daysToShip = parseInt(this.dataset.daysToShip) || 5;
    }

    connectedCallback() {
        if (!this.dateElement) return;
        const shippingDate = this.calculateShippingDate(this.daysToShip);
        this.dateElement.textContent = this.formatDate(shippingDate);
    }

    calculateShippingDate(daysToAdd) {
        let currentDate = new Date();
        let addedDays = 0;

        while (addedDays < daysToAdd) {
            currentDate.setDate(currentDate.getDate() + 1);
            // 0 is Sunday, 6 is Saturday. Skip them.
            if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
                addedDays++;
            }
        }

        return currentDate;
    }

    formatDate(date) {
        // Format: "Mon, Feb 09"
        const options = { weekday: 'short', month: 'short', day: '2-digit' };
        return date.toLocaleDateString('en-US', options);
    }
}

customElements.define('shipping-estimate', ShippingEstimate);
